var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 842,
    height: 719,
    viewBox: "0 0 842 719.45",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Link expired") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Two broken chain links in purple, indicating a magic sign-in link has expired or already been used.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.29,534.97l.05-26.06.54-5.66c9.5-99.64,92.24-177.19,192.45-179.45l54.27-.08c-11.95,29.32-18.11,59.02-18.46,90.65l-33.71.17c-59.62,1.4-106.12,51.51-104.62,109.89,1.52,59.41,50.43,105.18,110.44,105.07l216.57-.41c59.09-.11,105.82-49.7,105.64-107.49-.18-57.63-46.29-106.37-104.86-107.07l-20.05-.24c1-20.02,8.8-39.13,24.94-50.88l44.92-32.73c73.31,20.25,128.66,80.5,142.51,154.99,22.09,118.77-67.67,231.91-189.57,233.77l-229.99-.08c-99.42-1.56-181.03-80.81-190.48-178.35l-.59-6.05Z",
    fill: "#5f11ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M841.58,275.41l.02,26.74c-4.17,57.55-31.82,111.39-79.17,145.41l-108.7,78.08c-.11-34.41-6.04-66.6-19.56-97.71l71.39-51.04c48.61-34.76,59.95-101.79,25.93-149.88-34.16-48.28-101.36-60.24-150.2-25.37l-173.5,123.86c-41.82,29.86-60.02,81.99-40.88,130.1s66.77,74.41,117.27,66.16c-.24,37.45-29.85,68.05-67.18,68.13l-44.76.1c-58.69-31.48-97.46-91.33-102.98-156.36-5.81-68.34,22.56-135.82,78.39-175.97l178.12-128.08c60.94-43.82,140.02-51.64,208.69-16.8,60.17,30.52,102.69,93.04,107.14,162.63Z",
    fill: "#9979e2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319,0c9.99,3.06,15.46,11.23,15.08,22.15l-6.64,190.69c-.42,11.94-9.47,20.56-20.71,19.91s-19.07-9.89-18.65-21.89l6.66-190.74c.37-10.48,6.77-17.97,16.27-20.13h8Z",
    fill: "#5f11ea"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.17,231.14c4.84,11.42.68,22.85-10.11,27.36-10.46,4.37-21.47-.9-26.06-11.73L135.19,34.94c-4.44-10.48-1.43-21.59,8.67-26.7,9.27-4.69,22.17-1.36,26.72,9.37l90.59,213.53Z",
    fill: "#5f11ea"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.55,251.7c9.4,8.49,10.24,20.93,2.16,29.36-8.79,9.17-20.65,7.14-29.8-1.11L23.75,153.44c-8.8-7.94-10.27-20.05-2.51-28.73,7.74-8.66,20.05-8.59,28.87-.63l141.43,127.62Z",
    fill: "#5f11ea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpired);
export default __webpack_public_path__ + "static/media/link-expired.50b21044e23100a8335cb678282231a2.svg";
export { ForwardRef as ReactComponent };